// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.modulesSubmodules-container-section {
  flex-direction: column;
  border-radius: 4px;
  border: 1px solid #e0e0e0;
  padding: 16px;
}

.modules-container-section {
  width: 100%;
  margin-top: 16px;
}

.header-section {
  color: #4e4e4e;
  font-family: Inter;
  font-size: 20px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  letter-spacing: -0.02px;
}

.main-title-pregled-section,
.introspekcije-label {
  color: #4d4d4d;
  font-family: Inter;
  font-size: 40px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  letter-spacing: -0.04px;
}

.module-name-section,
.introspekcije-description {
  color: #5f6d7e;
  font-family: Inter;
  font-style: normal;
}
.module-name-section {
  display: flex;
  align-items: center;
  justify-content: space-between;
  cursor: pointer;
  font-size: 15px;
  font-weight: 600;
  letter-spacing: -0.015px;
  line-height: 22px;
}
.section-wrapper {
  flex-direction: column;
  display: flex;
  width: 100%;
}
.video-section-modules {
  height: 400px;
  width: 1000px;
  border: none;
}

.seperator-between-modules {
  border: 1px solid #d1d9e2;
}
.introspekcije-wrapper {
  display: flex;
  flex-direction: column;
  align-items: baseline;
  justify-content: center;
  gap: 16px;
}
.introspekcije-description {
  font-size: 16px;
  font-weight: 500;
  letter-spacing: -0.001em;
  margin-bottom: 64px;
  margin-top: 64px;
}
.introspekcije-label,
.introspekcije-no-comments {
  font-size: 20px;
  font-weight: 600;
}
.introspekcije-no-comments-container {
  border: 1px solid #d1d9e2;
  background-color: #ffffff;
  height: 200px;
  width: 100%;
  border-radius: 10px;
}
.introspekcije-no-comments {
  color: #5f6d7e;
  border: none;
  height: 200px;
  width: 100%;
  border-radius: 10px 0 0 10px;
  padding-left: 16px;
  resize: none;
  overflow-wrap: break-word;
  white-space: pre-wrap;
  box-sizing: border-box;
  padding-top: 14px;
}
.introspekcije-no-comments:focus {
  border: 1px solid #cb9c2d !important;
  outline: none !important;
  height: 200px;
}
.introspekcije-comments-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  width: 100%;
}
.instrospekcije-avatar-icon {
  width: 64px;
  height: 64px;
  border-radius: 100px;
  object-fit: cover;
}
.ql-toolbar.ql-snow {
  width: 100%;
  margin-bottom: -16px;
  border-top-right-radius: 8px;
  border-top-left-radius: 8px;
}

.introspekcije-save-btn,
.introspekcije-save-btn-wrapper,
.introspekcije-no-comments,
.introspekcije-edit-btn,
.missing-video-display,
.introspekcije-no-comments-container {
  display: flex;
  align-items: center;
  justify-content: center;
}
.introspekcije-save-btn-wrapper {
  width: 100%;
  margin-top: 24px 0px 24px 0px;
  gap: 25px;
}
.introspekcije-edit-btn {
  width: 56px;
  height: 200px;
  border: none;
  border-radius: 0 9px 9px 0;
  background-color: #f4f4f4;
}
.introspekcije-edit-btn:hover {
  background-color: #e2e2e2;
}
.introspekcije-edit-btn,
.introspekcije-save-btn {
  cursor: pointer;
  transition: background-color 300ms ease-in-out;
}
.introspekcije-save-btn {
  border-radius: 4px;
  background-color: #cb9c2d;
  column-gap: 8px;
  height: 52px;
  width: 15%;
  border: none;
  font-family: Inter;
  font-size: 15px;
  font-weight: 600;
  line-height: 22px;
  letter-spacing: -0.001em;
  text-align: center;
  color: white;
}
.introspekcije-save-btn:hover {
  background-color: #a37d25;
}
.pdf-container {
  width: 100%;
  height: 550px;
  overflow: hidden;
  background-color: #d6c8ae;
  margin-top: 150px;
}

.pdf-page {
  display: flex;
  justify-content: center;
  padding: 5px;
}

.missing-video-display {
  cursor: pointer;
}
.video-link {
  font-family: Inter;
  font-size: 28px;
  font-weight: 500;
  line-height: 22px;
  letter-spacing: -0.001em;
  color: #4e4e4e;
  text-decoration: none;
}

.input-text {
  font-family: Inter;
  font-size: 16px;
  font-weight: 600;
  line-height: 22px;
  letter-spacing: -0.001em;
  color: #5f6d7e;
  text-decoration: none;
}
.zoom-container,
.endContainer {
  width: 90%;
  border-radius: 4px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 20px;
  box-sizing: border-box;
  padding-top: 40px;
  margin: 0 40px;
}

.zoom-container {
  border: 1px solid #e0e0e0;
  height: 480px;
}

#join-p,
#end-p {
  font-family: Inter;
  font-size: 15px;
  font-weight: 600;
  letter-spacing: -0.001em;
  color: #5f6d7e;
}

.join-btn,
.end-btn {
  font-family: Inter;
  font-size: 15px;
  font-weight: 600;
  letter-spacing: -0.001em;
  color: white;
  background-color: #cb9c2d;
  height: 40px;
  width: 150px;
  border-radius: 8px;
  border: none;
}
.join-btn:hover,
.end-btn:hover {
  background-color: #ae8320;
  cursor: pointer;
}

.endContainer {
  visibility: hidden;
  position: absolute;
  width: 0px;
}

@media screen and (max-width: 1440px) {
  .modulesSubmodules-container-section {
    width: 100%;
  }
}
@media screen and (max-width: 1024px) {
  .section-wrapper {
    width: 100%;
    align-items: center;
    justify-content: center;
  }
  .modulesSubmodules-container-section {
    width: 80%;
  }
  .section-navigation-breakpoint {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    padding-bottom: 24px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/scenes/pojediniProgrami/SectionContainer/Section.css"],"names":[],"mappings":"AAAA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,yBAAyB;EACzB,aAAa;AACf;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;;EAEE,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;;EAEE,cAAc;EACd,kBAAkB;EAClB,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,wBAAwB;EACxB,iBAAiB;AACnB;AACA;EACE,sBAAsB;EACtB,aAAa;EACb,WAAW;AACb;AACA;EACE,aAAa;EACb,aAAa;EACb,YAAY;AACd;;AAEA;EACE,yBAAyB;AAC3B;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,qBAAqB;EACrB,uBAAuB;EACvB,SAAS;AACX;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,wBAAwB;EACxB,mBAAmB;EACnB,gBAAgB;AAClB;AACA;;EAEE,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,aAAa;EACb,WAAW;EACX,mBAAmB;AACrB;AACA;EACE,cAAc;EACd,YAAY;EACZ,aAAa;EACb,WAAW;EACX,4BAA4B;EAC5B,kBAAkB;EAClB,YAAY;EACZ,yBAAyB;EACzB,qBAAqB;EACrB,sBAAsB;EACtB,iBAAiB;AACnB;AACA;EACE,oCAAoC;EACpC,wBAAwB;EACxB,aAAa;AACf;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,WAAW;AACb;AACA;EACE,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,iBAAiB;AACnB;AACA;EACE,WAAW;EACX,oBAAoB;EACpB,4BAA4B;EAC5B,2BAA2B;AAC7B;;AAEA;;;;;;EAME,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,WAAW;EACX,6BAA6B;EAC7B,SAAS;AACX;AACA;EACE,WAAW;EACX,aAAa;EACb,YAAY;EACZ,0BAA0B;EAC1B,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;;EAEE,eAAe;EACf,8CAA8C;AAChD;AACA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,eAAe;EACf,YAAY;EACZ,UAAU;EACV,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,wBAAwB;EACxB,kBAAkB;EAClB,YAAY;AACd;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,WAAW;EACX,aAAa;EACb,gBAAgB;EAChB,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,YAAY;AACd;;AAEA;EACE,eAAe;AACjB;AACA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,wBAAwB;EACxB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,wBAAwB;EACxB,cAAc;EACd,qBAAqB;AACvB;AACA;;EAEE,UAAU;EACV,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,sBAAsB;EACtB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,aAAa;AACf;;AAEA;;EAEE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,wBAAwB;EACxB,cAAc;AAChB;;AAEA;;EAEE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,wBAAwB;EACxB,YAAY;EACZ,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,YAAY;AACd;AACA;;EAEE,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE;IACE,WAAW;EACb;AACF;AACA;EACE;IACE,WAAW;IACX,mBAAmB;IACnB,uBAAuB;EACzB;EACA;IACE,UAAU;EACZ;EACA;IACE,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,WAAW;IACX,oBAAoB;EACtB;AACF","sourcesContent":[".modulesSubmodules-container-section {\n  flex-direction: column;\n  border-radius: 4px;\n  border: 1px solid #e0e0e0;\n  padding: 16px;\n}\n\n.modules-container-section {\n  width: 100%;\n  margin-top: 16px;\n}\n\n.header-section {\n  color: #4e4e4e;\n  font-family: Inter;\n  font-size: 20px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: normal;\n  letter-spacing: -0.02px;\n}\n\n.main-title-pregled-section,\n.introspekcije-label {\n  color: #4d4d4d;\n  font-family: Inter;\n  font-size: 40px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: normal;\n  letter-spacing: -0.04px;\n}\n\n.module-name-section,\n.introspekcije-description {\n  color: #5f6d7e;\n  font-family: Inter;\n  font-style: normal;\n}\n.module-name-section {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  cursor: pointer;\n  font-size: 15px;\n  font-weight: 600;\n  letter-spacing: -0.015px;\n  line-height: 22px;\n}\n.section-wrapper {\n  flex-direction: column;\n  display: flex;\n  width: 100%;\n}\n.video-section-modules {\n  height: 400px;\n  width: 1000px;\n  border: none;\n}\n\n.seperator-between-modules {\n  border: 1px solid #d1d9e2;\n}\n.introspekcije-wrapper {\n  display: flex;\n  flex-direction: column;\n  align-items: baseline;\n  justify-content: center;\n  gap: 16px;\n}\n.introspekcije-description {\n  font-size: 16px;\n  font-weight: 500;\n  letter-spacing: -0.001em;\n  margin-bottom: 64px;\n  margin-top: 64px;\n}\n.introspekcije-label,\n.introspekcije-no-comments {\n  font-size: 20px;\n  font-weight: 600;\n}\n.introspekcije-no-comments-container {\n  border: 1px solid #d1d9e2;\n  background-color: #ffffff;\n  height: 200px;\n  width: 100%;\n  border-radius: 10px;\n}\n.introspekcije-no-comments {\n  color: #5f6d7e;\n  border: none;\n  height: 200px;\n  width: 100%;\n  border-radius: 10px 0 0 10px;\n  padding-left: 16px;\n  resize: none;\n  overflow-wrap: break-word;\n  white-space: pre-wrap;\n  box-sizing: border-box;\n  padding-top: 14px;\n}\n.introspekcije-no-comments:focus {\n  border: 1px solid #cb9c2d !important;\n  outline: none !important;\n  height: 200px;\n}\n.introspekcije-comments-row {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 16px;\n  width: 100%;\n}\n.instrospekcije-avatar-icon {\n  width: 64px;\n  height: 64px;\n  border-radius: 100px;\n  object-fit: cover;\n}\n.ql-toolbar.ql-snow {\n  width: 100%;\n  margin-bottom: -16px;\n  border-top-right-radius: 8px;\n  border-top-left-radius: 8px;\n}\n\n.introspekcije-save-btn,\n.introspekcije-save-btn-wrapper,\n.introspekcije-no-comments,\n.introspekcije-edit-btn,\n.missing-video-display,\n.introspekcije-no-comments-container {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n.introspekcije-save-btn-wrapper {\n  width: 100%;\n  margin-top: 24px 0px 24px 0px;\n  gap: 25px;\n}\n.introspekcije-edit-btn {\n  width: 56px;\n  height: 200px;\n  border: none;\n  border-radius: 0 9px 9px 0;\n  background-color: #f4f4f4;\n}\n.introspekcije-edit-btn:hover {\n  background-color: #e2e2e2;\n}\n.introspekcije-edit-btn,\n.introspekcije-save-btn {\n  cursor: pointer;\n  transition: background-color 300ms ease-in-out;\n}\n.introspekcije-save-btn {\n  border-radius: 4px;\n  background-color: #cb9c2d;\n  column-gap: 8px;\n  height: 52px;\n  width: 15%;\n  border: none;\n  font-family: Inter;\n  font-size: 15px;\n  font-weight: 600;\n  line-height: 22px;\n  letter-spacing: -0.001em;\n  text-align: center;\n  color: white;\n}\n.introspekcije-save-btn:hover {\n  background-color: #a37d25;\n}\n.pdf-container {\n  width: 100%;\n  height: 550px;\n  overflow: hidden;\n  background-color: #d6c8ae;\n  margin-top: 150px;\n}\n\n.pdf-page {\n  display: flex;\n  justify-content: center;\n  padding: 5px;\n}\n\n.missing-video-display {\n  cursor: pointer;\n}\n.video-link {\n  font-family: Inter;\n  font-size: 28px;\n  font-weight: 500;\n  line-height: 22px;\n  letter-spacing: -0.001em;\n  color: #4e4e4e;\n  text-decoration: none;\n}\n\n.input-text {\n  font-family: Inter;\n  font-size: 16px;\n  font-weight: 600;\n  line-height: 22px;\n  letter-spacing: -0.001em;\n  color: #5f6d7e;\n  text-decoration: none;\n}\n.zoom-container,\n.endContainer {\n  width: 90%;\n  border-radius: 4px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 20px;\n  box-sizing: border-box;\n  padding-top: 40px;\n  margin: 0 40px;\n}\n\n.zoom-container {\n  border: 1px solid #e0e0e0;\n  height: 480px;\n}\n\n#join-p,\n#end-p {\n  font-family: Inter;\n  font-size: 15px;\n  font-weight: 600;\n  letter-spacing: -0.001em;\n  color: #5f6d7e;\n}\n\n.join-btn,\n.end-btn {\n  font-family: Inter;\n  font-size: 15px;\n  font-weight: 600;\n  letter-spacing: -0.001em;\n  color: white;\n  background-color: #cb9c2d;\n  height: 40px;\n  width: 150px;\n  border-radius: 8px;\n  border: none;\n}\n.join-btn:hover,\n.end-btn:hover {\n  background-color: #ae8320;\n  cursor: pointer;\n}\n\n.endContainer {\n  visibility: hidden;\n  position: absolute;\n  width: 0px;\n}\n\n@media screen and (max-width: 1440px) {\n  .modulesSubmodules-container-section {\n    width: 100%;\n  }\n}\n@media screen and (max-width: 1024px) {\n  .section-wrapper {\n    width: 100%;\n    align-items: center;\n    justify-content: center;\n  }\n  .modulesSubmodules-container-section {\n    width: 80%;\n  }\n  .section-navigation-breakpoint {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    width: 100%;\n    padding-bottom: 24px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
